<template>
    <rkm-form>
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="data.form.encaminhamentoSetores"
                    :validations="validations.centroCustoIdPara"
                    name="Setor de encaminhamento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.centroCustoIdPara"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                centroCustoIdPara: {
                    required: this.required,
                },
            }
        }
    },
    props: {
        data: { type: Object, required: true },
        required: { type: Boolean, default: true },
    },
}
</script>